import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import { connect } from "react-redux"
import { fillingZeroUtility, LoanStatus, UserRoles } from "../../lib/utils"
import { assignToNewUser } from "../../redux/actions/loans"
import * as ItemTypes from "../../redux/items/types"
import store from "store"
import jwtDecode from "jwt-decode"
import AlertModal from "../fragments/AlertModal"

/**
 * Loan reassignment/unassignment
 */
class AssignToForm extends React.Component {

  state = {
    username: '',
    show: false,
  }

  componentDidMount() {
    this.props.loadUsers()
  }

  makeAssignment = () => {

    const { makeAssignTo, callback, selectedLoans } = this.props,
      { username } = this.state

    selectedLoans.forEach(loan => {
      if (this.extractUsername(loan) !== username) {
        makeAssignTo(loan.id, username)
      }
    })

    if (callback) {
      callback()
    }
    this.handleClose()
  }

  extractUsername = loan => loan.assignTo ? loan.assignTo.username : ''

  getUsername = loans => {
    let username = ''
    if (loans.length) {
      const firsUserName = this.extractUsername(loans[0]),
        isSameUsername = loans.findIndex(loan => this.extractUsername(loan) !== firsUserName) === -1
      username = isSameUsername ? firsUserName : ''
    }

    return username
  }

  handleShow = () => this.setState({ show: true })

  handleClose = () => this.setState({ show: false })

  render() {

    const { selectedLoans, users, nbItems } = this.props,
      { show, username } = this.state,

      assignTo = this.getUsername(selectedLoans),

      title = <span>{ username ? 'Confirm assignment' : 'Confirm unassignment' }</span>,
      pronoun = nbItems > 1 ? `these ${ fillingZeroUtility(nbItems) } loans` : 'this loan',
      body = <h3>{ username ? `Are you sure you want to assign ${ pronoun } to ${ username }?`
      : `Are you sure you want to unassign ${ pronoun }?` }</h3>,

      bsStyle= username ? 'primary' : 'danger',
      proceedText = username ? 'Assign' : 'Unassign'

    return (
      <span>
        <select
          className="assignToSelect"
          value={ assignTo }
          onChange={e => {
            this.setState({ username: e.target.value })
            this.handleShow()
          }}>
          <option value=""></option>
          { users.map(user =>
            <option key={ user.username } value={ user.username }>{ user.name } ({ user.username })</option>
          )}
        </select>

        <AlertModal
          show={ show }
          close={ this.handleClose }
          confirm={ this.makeAssignment }
          title={ title }
          body={ body }
          bsStyle={ bsStyle }
          proceedText={ proceedText }
        />
      </span>
    )
  }
}

const filterForAssignTo = (users, role, currentUsername) =>
  users.filter(user => user.userRole === role
    || user.userRole === UserRoles.ADMIN || user.username === currentUsername),

mapStateToProps = (state, ownProps) => {

  let users = DckSelectors.selectAllItems(state, ItemTypes.User)

  const userToken = store.get("sessionData").access_token,
    currentUsername = userToken ? jwtDecode(userToken).user_name : null

  // Filter the list
  switch(ownProps.loanStatus) {

    case LoanStatus.UNDERWRITER_REVIEW:
    case LoanStatus.UNDERWRITER_DECLINED:
      users = filterForAssignTo(users, UserRoles.UNDERWRITER, currentUsername)
      break

    case LoanStatus.APPROVER_REVIEW:
    case LoanStatus.DECLINED:
      users = filterForAssignTo(users, UserRoles.APPROVER, currentUsername)
      break

    case LoanStatus.APPROVED:
      users = filterForAssignTo(users, UserRoles.CREATOR, currentUsername)
      break

    case LoanStatus.COMPLETED:
      users = filterForAssignTo(users, UserRoles.ACCOUNTANT, currentUsername)
      break

    default:
      users = []
      break
  }

  return { users }
},

mapDispatchToProps = dispatch => ({
  loadUsers: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.User)),
  makeAssignTo: (loanId, username) => dispatch(assignToNewUser(loanId, username))
})

export default connect(mapStateToProps, mapDispatchToProps)(AssignToForm)



// WEBPACK FOOTER //
// ./src/components/Loans/AssignToForm.js